<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery="">
    </qx-search-box>

    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {companyBankcardList, getOtherIncomeSysData, getPaymentDetailsSysData} from 'api/getPay';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        accountNameOptions: [], // 账户名称
        transactionPurposeOptions: [], // 交易用途
        accountTypeOptions: [], // 账户类型
        transactionModeOptions: [], // 交易方式
        form: [
          { // 交易流水
            label: '交易流水',
            value: 'transactionNoFlow',
            type: 'input',
            placeholder: '请输入交易编号',
          },
          { // 账户名称
            label: '账户名称',
            value: 'accountName',
            type: 'select',
            placeholder: '请选择账户名称',
            onvisibilitychange: () => {
              this.searchBoxData.accountNameOptions = [];
              this.getAccountData();
            },
          },
          { // 账户类型
            label: '账户类型',
            value: 'accountType',
            type: 'checkbox',
          },
          { // 交易方式
            label: '交易方式',
            value: 'transactionMode',
            type: 'checkbox',
          },
          { // 交易用途
            label: '交易用途',
            value: 'transactionPurpose',
            type: 'select',
            default: -1,
            placeholder: '请选择交易用途',
            onvisibilitychange: () => {
              this.searchBoxData.transactionPurposeOptions = [];
              this.getEnum();
            },
          },
          { // 对方账户
            label: '对方账户',
            value: 'oppositeAccountNumber',
            type: 'input',
            placeholder: '请输入对方账户',
          },
          { // 对方户名
            label: '对方户名',
            value: 'oppositeAccountName',
            type: 'input',
            placeholder: '请输入对方户名',
          },
          { // 交易时间
            label: '交易时间',
            value: 'transactionTime',
            type: 'date',
            placeholder: '请输入交易时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 交易时间
      if (searchBoxData.transactionTime && searchBoxData.transactionTime.length) { // 请求时间
        searchBoxData.transactionTimeBegin = this.formatDate(searchBoxData.transactionTime[0]);
        searchBoxData.transactionTimeEnd = this.formatDate(searchBoxData.transactionTime[1]);
        delete searchBoxData.transactionTime;
      }

      if (searchBoxData.accountName) { // 账户名称
        this.searchBoxData.accountNameOptions.map((item) => {
          if (searchBoxData.accountName && item.bankCardNo === searchBoxData.accountName) {
            searchBoxData.accountName = item.accountName;
          }
        });
      }
      // delete searchBoxData.accountName;


      if (searchBoxData.accountType) { // 账户类型
        if (searchBoxData.accountType.length <= 1) {
          searchBoxData.accountType = searchBoxData.accountType.toString();
          // delete searchBoxData.accountType;
        } else {
          delete searchBoxData.accountType;
        }
      }

      if (searchBoxData.transactionMode) { // 交易方式
        if (searchBoxData.transactionMode.length <= 1) {
          searchBoxData.transactionMode = searchBoxData.transactionMode.toString();

        } else {
          delete searchBoxData.transactionMode;
        }
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    async getEnum () {
      const enumsList = await getEnumList({ // 账户类型
        codeType: 'ACCOUNT_TYPE,TRANSACTION_MODE',
      });

      if (enumsList) {
        let data = enumsList[0].filter(function (item) {
          return item.codeId === 128001 || item.codeId === 128002;
        });
        this.searchBoxData.accountTypeOptions = data;
      }

      this.searchBoxData.transactionModeOptions = [ // 交易方式
        ...enumsList[1],
      ];

      const transactionPurposeOptionsList = await getPaymentDetailsSysData({ // 交易用途
        codeType: 'TRANSACTION_PURPOSE,BUSINESS_NUMBER_TYPE',
      });
      this.searchBoxData.transactionPurposeOptions = [ // 交易用途
        {
          label: '全部',
          value: -1,
        },
        ...transactionPurposeOptionsList[0],
        ...transactionPurposeOptionsList[1],
      ];
    },
    async getAccountData () {
      const res = await companyBankcardList();// 账户名称
      let priObj = {};
      if (res.allPriAcct.length > 0) {
        priObj = res.allPriAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,
        }));
        this.searchBoxData.accountNameOptions.push(...priObj);
      }
      let pubObj = {};
      if (res.allPubAcct.length > 0) {
        pubObj = res.allPubAcct.map((item) => ({
          label: item.acctName, // 账户名称
          value: item.acctNo, // 银行卡号s
          accountType: item.bankType, // 账户类型
          bankCardNo: item.acctNo,
          accountName: item.acctName,
        }));
        this.searchBoxData.accountNameOptions.push(...pubObj);
      }

    },
  },
  async created () {
    await this.getEnum();
    await this.getAccountData();
  },
};
</script>

<style lang="scss" scoped>
</style>
